import axios from "axios";
import Config from "../../config/index";
import {
  CREATE_PAYMENT_FAILURE,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  GET_PAYMENT_FAILURE,
  GET_PAYMENT_REQUEST,
  GET_PAYMENT_SUCCESS,
} from "./paymentTypes";

let baseUrl = "https://swms.mobillor.net/lms_dev_api";

const getPaymentRequest = () => {
  return {
    type: GET_PAYMENT_REQUEST,
  };
};

const getPaymentSuccess = (payload) => {
  return {
    type: GET_PAYMENT_SUCCESS,
    payload: payload,
  };
};

const getPaymentFailure = (error) => {
  return {
    type: GET_PAYMENT_FAILURE,
    payload: error,
  };
};

const getPayment = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPaymentRequest());
    let url = `${baseUrl}/api/v2/plan_management/plans/list_formatted`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPaymentSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPaymentFailure(err.message));
      });
  };
};

const createPaymentRequest = () => {
  return {
    type: CREATE_PAYMENT_REQUEST,
  };
};

const createPaymentSuccess = (payload) => {
  return {
    type: CREATE_PAYMENT_SUCCESS,
    payload: payload,
  };
};

const createPaymentFailure = (error) => {
  return {
    type: CREATE_PAYMENT_FAILURE,
    payload: error,
  };
};

const createPayment = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPaymentRequest());
    let url = `${baseUrl}/api/v2/new_subscription_management/new_subscription/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPaymentSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPaymentFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getPayment, createPayment };
